module.exports = __webpack_public_path__ + "img/java.74e943d8.png";